<template>
    <div>

        <div class="pchome-headerss top-header">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>


        <position-bar :productc_nav="producthea_nav" :positionNav="positionNav">

        </position-bar>

        <div style="padding:10px 0;opacity:0" v-if="producthea_nav">
            <div class="videohea-left">
                {{title}}
            </div>
        </div>
        <div class="linesd"></div>

        <div class="detail-page">
            <div class="detail-page-cnt">
                <div class="detail-page-top">
                    <div class="detail-data">{{ data.createtime ? $utils.formatDate(data.createtime) : '' }}</div>
                    <h3 class="detail-h3">{{ data.en_title }}</h3>
                    <div class="top-icon">
                    </div>
                    <div class="top-tips clearfix">
                        <div class="top-tips clearfix">

                        </div>
                    </div>
                    <div class="info_con">
                        <div class="detail-page-bd">
                            <div class="html-text-component parbase">
                                <span class="one_line"></span>
                                <div id="news_contain" v-html="data.en_content">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="linesd" style="width: 100%"></div>
            <div class="pagination">
                <div class="prev" @click="toPrev" >
                    <span v-if="data.prev"><i class="el-icon-back"></i>上一页</span>
                </div>
                <div class="next" @click="toNext" v-if="data.next">
                    <span v-if="data.next">下一页 <i class="el-icon-right"></i></span>
                </div>
            </div>
        </div>


        <footers ref=is_change ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'

    export default {
        name: "pc-news-detail",
        components:{
            headers,
            footers,
            positionBar,
        },
        data(){
            return {
                producthea_nav:false,
                nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
                videoclassallss:[],
                title:'新闻',
                videotopnavind:0,
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'News',
                        path:'/pc-news',
                    },
                    {
                        title:'',
                        paht:''
                    }
                ],
                id:0,
                data:{
                    en_title:'',
                    en_content:'',
                },
            }
        },
        created(options){
            const {id} = this.$route.query
            this.id = id
        },
        watch:{
            '$route': 'getParams'
        },
        mounted(options) {

            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'./ph-news-detail',query:{id:this.$route.query.e}})
            }

            sessionStorage.setItem('page',JSON.stringify({name:'pc-news-detail',data:false}))

            this.detail()
        },
        methods:{
            getParams(){
                this.id = this.$route.query.id
                this.detail()
            },
            toPrev(){
                this.$router.push({path: '/pc-news-detail',query:{
                    id:this.data.prev.id
                    }})
            },
            toNext(){
                this.$router.push({path: '/pc-news-detail',query:{
                        id:this.data.next.id
                    }})
            },
            detail(){
                this.$api.get_news_center_detail({id:this.id}).then(res => {
                    if(res.code <= 0){
                        this.$router.push({path: '/pc-news'})
                        return
                    }
                    this.data = res.data
                    this.positionNav[2].title = res.data.en_title
                })
            },
            ChangeEmit(){ //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
            },
            videoclinav(e){
                this.videotopnavind=e
                this.classidd=this.videoclassallss[e].id
                // this.videoclasslist()
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop)
            },
        }
    }
</script>

<style>
    .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }
    .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .videohea-right{
        display: flex;


    }
    .videohea-righttitle{
        max-width: 800px;

        display: flex;

        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
        color: #5d5f5f;
    }
    .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;
    }
    .producthearight-item:first-child{
        margin-left: 0px;
    }
    .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
    }
    .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }


    .detail-page {
        width: 808px;
        margin: 0 auto;
        padding-bottom: 80px;
        word-break: break-all;
        word-wrap: break-word
    }

    .detail-page .detail-page-cnt {
        padding: 50px 0 30px;
    }

    .detail-page .detail-page-top .detail-data {
        font-weight: 700;
        font-size: 18px;
        color: #6f6f6f;
        margin-bottom: 30px;
    }

    .detail-page .detail-page-top .detail-h3 {
        font-weight: 600;
        font-size: 36px;
        color: #5d5f5f;
        line-height: 44px;
        margin-bottom: 40px;
        word-break: break-word;
    }

    .detail-page .detail-page-top .top-icon {
        padding-bottom: 30px;
        border-bottom: 1px solid #e0e0e0
    }


    .detail-page .detail-page-bd .html-text-component  {
        font-size: 18px;
        color: #6f6f6f;
        letter-spacing: 0;
        line-height: 32px;
        margin-bottom: 20px;
        word-break: break-word;
        margin-top: 50px;
    }

    .detail-page .detail-page-bd .html-text-component img {
        max-width: 100%;
    }
    .detail-page .pagination {
        font-size: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
    }
    .detail-page .pagination .prev,
    .detail-page .pagination .next {
        cursor: pointer;
        color: rgba(0,0,0, .7);
        transition: all .3s linear 0s;
    }
    .detail-page .pagination .prev:hover,
    .detail-page .pagination .next:hover{
        color: rgba(0,0,0, 1);
    }
</style>